import React from 'react';

import { HashRouter as Router, useLocation } from 'react-router-dom';

import LoadPanel from 'devextreme-react/load-panel';

import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { ContractTypesProvider } from './contexts/contract-types';
import { useScreenSizeClass } from './utils/media-query';
import { Content } from './Content';
import { UnauthenticatedContent } from './UnauthenticatedContent';

import 'devexpress-gantt/dist/dx-gantt.css';
import './styles.scss';
import './theme/theme';
import { useThemeContext, ThemeContext } from './theme/theme';
import * as nlMessages from 'devextreme/localization/messages/nl.json';
import * as localization from 'devextreme/localization';
function RootApp() {

  const { user, loading } = useAuth();
  const isLoginForm = [
    'login',
    'reset-password',
    'create-account',
  ].includes(useLocation().pathname.substring(1));

  if (loading) {
    return <LoadPanel visible />;
  }

  if (user && !isLoginForm) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export const App = () => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();
  localization.loadMessages(nlMessages);
  localization.loadMessages({
    'nl': {
        'dxScheduler-allDay': 'Hele dag',
    }
  });
  localization.locale(navigator.language);
  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <AuthProvider>
          <ContractTypesProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              {
                themeContext.isLoaded ? <RootApp /> : ''
              }
            </div>
          </NavigationProvider>
          </ContractTypesProvider>
        </AuthProvider>
      </ThemeContext.Provider>
    </Router>
  );
};
